import { setTheme } from "theme/default/setTheme";

export const setFontSize_13px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_13px}`);
